<template>
    <div class="d-flex container-fluid mr-0 mt-4 ml-0 g-3 p-0 align-items-center input" :class="{ 'mt-0': this.first, 'justify-content-between': labelTop }">
        <div class="d-flex align-items-center p-0 mt-0" :class="{ 'col-6': !labelTop }">
            <label :for="id" :class="{ 'primary-grey': !labelTop, 'fsp14 lh20': labelTop }">
                {{this.label}}
                <span class='require' v-if="this.require"> *</span>
            </label>
            <Popper v-if="this.hint" :hover="true" :id="id + '_hint'">
                <Icon name="info" size="c16" class="ml4" />
                <template #content>
                    <span>{{ this.hint }}</span>
                </template>
            </Popper>
        </div>
        <div class="p-0 input-wrapper mt-0 d-flex align-items-center gap-2" :class="{ 'col-6': !labelTop }">
            <SwitchSimple 
                :id="id" 
                :dataValue='this.dataValue' 
                :disabled="this.disabled" 
                :type="this.type" 
                @updateParentState="this.setValue"
            />
            <div class="d-flex flex-row align-items-center justify-content-end gap-2">
                <!-- <div v-else-if="this.unvisible" class="mw34"></div> -->
                <Popper 
                    v-if="this.verification"
                    :id="id + '_check'"
                    :hover="true"
                >
                    <Icon name="check-mark" :color="{ 0: '#018A5A'}" class="c18" />
                    <template #content>
                        <span>{{ $t('views.InfoReg.3') }}</span>
                    </template>
                </Popper>
                <!-- <div v-else-if="this.unvisible || this.vMark" class="mw34"></div> -->
                <Popper v-if="this.unvisible" :hover="true" :id="id + '_av'">
                    <SwitchSimple 
                        :id="id + '_switch_id'" 
                        :dataValue='this.unvisibleValue'  
                        :disabled="this.is_public == '2' ? true : false" 
                        :type="'sm'" class="ml-1" 
                        @updateParentState="this.setUnvisibleValue"
                    />
                    <template #content>
                        <span>{{ $t('views.InfoReg.4') }}</span>
                    </template>
                </Popper>
            </div>
        </div>
    </div>
</template>

<script>
import SwitchSimple from '@/components/service/SwitchSimple';
import Tooltip from '@/components/service/Tooltip';
import Icon from '@/components/icons/Icon';
import Popper from '@/components/service/Popper';

export default {
    components: {
        Tooltip,
        SwitchSimple,
        Icon,
        Popper
    },
    data() {
        return {
            value: this.dataValue ? true : false,
            unvisibleValue: this.unvisibleDataValue ? this.unvisibleDataValue : '',
        }
    },
    props: {
        id: [String, Boolean],
        label: [String],
        hint: [String],
        verification: [String, Boolean],
        first: {
            type: Boolean,
            default: false,
        },
        type: {
            default: 'form-switch-xl',
            type: [String]
        }, 
        require: [Boolean],
        disabled: [String, Boolean],
        dataValue: [String, Boolean],
        unvisible: [Boolean],
        unvisibleDataValue: [String, Boolean], 
        vMark: [Boolean],
        is_public: [Boolean, String],
        labelTop: [Boolean]
    },
    methods: {
        setValue(arg) {
            this.$emit('updateParentState', {
                id: arg.id,
                value: arg.value
            })
        },
        setUnvisibleValue(arg) {
            this.$emit('updateParentState', {
                id: arg.id.replace(/_switch_id/, ''),
                unvisible: true,
                value: arg.value
            })
        },
    },

}
</script>

<style lang="scss" scoped>
.input {
    font-family: 'HelveticaNeue roman';
    &-wrapper {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
    }
}
.mt-1 {
    margin: 0 !important;
}
.require {
    color: red;
}
</style>